import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { UserRole } from '../../types';
import { Box, CircularProgress } from '@mui/material';

interface RestrictedRouteProps {
  children: React.ReactNode;
  excludedRoles?: UserRole[];
  redirectTo?: string;
}

const RestrictedRoute: React.FC<RestrictedRouteProps> = ({ 
  children, 
  excludedRoles = [],
  redirectTo = '/superadmin'
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user && excludedRoles.includes(user.role)) {
    // User has excluded role, redirect to specified route
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RestrictedRoute;











